import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { QuestionBlock } from '../';

/* eslint-disable */
export const QuestionListing = styled.div`
  width: 100%;
  margin-bottom: 60px;

  ${/* sc-sel */ QuestionBlock} {
    margin: 0;
  }

  ${minMediaQueries.miniDesktop`
    display: flex;
    justify-content: space-between;
    max-width: ${({ theme }) => theme.maxWidth};
    margin: 0 auto;
  `};
`;
/* eslint-enable */
